import * as React from "react";
import {handleNavigation, routePaths} from "egold/routes";
import {imageBaseUrl} from "config";
import {IReduxState} from "reducers";
import {notifyAndroid} from "utils/android";
import {useEffect} from "react";
import {HeaderTitle} from "egold/utils";
import {AndroidApis} from "app";
import {useSelector} from "react-redux";

interface IProps {
    title: string;
}

export default function EGoldHeaderNav(props: IProps) {
    const isAndroid: boolean = useSelector((state: IReduxState) => state.login.isAndroid);
    const navigablePages = [
        {
            name: HeaderTitle.BUY,
            icon: `${imageBaseUrl}/img/icons/eGold/Buy_Gold.png`,
            activeIcon: `${imageBaseUrl}/img/icons/eGold/Buy_Gold_active.png`,
            routePaths: routePaths.BUY_GOLD,
        },
        {
            name: HeaderTitle.LOCKER,
            icon: `${imageBaseUrl}/img/icons/eGold/Locker.png`,
            activeIcon: `${imageBaseUrl}/img/icons/eGold/Locker_active.png`,
            routePaths: routePaths.LOCKER,
        },
        {
            name: HeaderTitle.DELIVERY,
            icon: `${imageBaseUrl}/img/icons/eGold/Delivery.png`,
            activeIcon: `${imageBaseUrl}/img/icons/eGold/Delivery_active.png`,
            routePaths: routePaths.DELIVERY,
        },
        {
            name: HeaderTitle.SELL,
            icon: `${imageBaseUrl}/img/icons/eGold/Sell _gold.png`,
            activeIcon: `${imageBaseUrl}/img/icons/eGold/Sell _gold_active.png`,
            routePaths: routePaths.SELL_GOLD,
        },
        {
            name: HeaderTitle.ORDERS,
            icon: `${imageBaseUrl}/img/icons/eGold/Order.png`,
            activeIcon: `${imageBaseUrl}/img/icons/eGold/Order_active.png`,
            routePaths: routePaths.ORDERS,
        },
    ];
    useEffect(() => {
        if (isAndroid) {
            notifyAndroid("TOOL_BAR_CONFIG", {visibility: true, title: props.title});
            AndroidApis.clearWebStack();
        }
    }, []);
    function handleClick(path: string, title: string) {
        handleNavigation(path);
    }
    return (
        <div className={"egold-header"} style={isAndroid ? {top: "0px"} : {top: "67px"}}>
            {
                navigablePages.map((page, index) => {
                   return (
                       <div
                           key={index}
                           className={`egold-header-nav ${page.name.includes(props.title) && "active"}`}
                           onClick={() => handleClick(page.routePaths, page.name)}
                       >
                           <img src={page.name.includes(props.title) ? page.activeIcon : page.icon} style={{width: "25px"}}/>
                           <div>{page.name}</div>
                       </div>
                   );
                })
            }
        </div>
    );
}
